<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData);
});


function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);

  var dateCar = listData.time;

  var dataCar = listData.list;
  var datas =  {
    date:dateCar,data:dataCar,opacityNum:0
  }

  var rotate= 0;
  var date = datas.date;
  var data = datas.data;
  var opacityNum = datas.opacityNum;
  const option= {
    tooltip: {
      trigger: 'axis',
      position: function (pt) {
        return [pt[0], '10%'];
      }
    },
    grid: {

      top: '15%',
      bottom: '10%',
      left: '13%',
      right: '10%'
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: date,
      name:'',
      nameTextStyle:{
        color:'rgba(51, 152, 255, 1)',
        fontSize: 30,
      },
      axisLabel:{
        color:'#fff',  //x轴文字颜色
        fontSize: 26,
        interval:0,
        padding:[10,0,0,0]
      },
      axisLine:{  //x轴轴线
        lineStyle:{
          color:'rgba(25,55,78,1)',
          width: 2
        },

      },
      axisTick: {//刻度线
        show: false
      },

    },
    yAxis: {
      type: 'value',
      //  boundaryGap: [0, '100%'],

      // nameTextStyle:{
      //   color:'rgba(51, 152, 255, 1)',
      //   fontSize: 26,
      // },
      axisLabel:{
        color:'#fff',
        fontSize: 26,
        padding:[0,20,0,0]
      },
      axisLine:{  //x轴轴线
        lineStyle:{
          color:'rgba(102,193,255,1)',
          width: 2
        },
      },
      splitLine:{//分割线
        show:true,
        lineStyle: {
          color: 'rgba(102,193,255,.5)',
          width: 1,
          type: 'dashed',
        }
      },
      axisTick: {
        show: false
      },
    },

    series: [
      {
        name:'上报数量',
        type:'line',
        smooth:true,
        symbol:'none',
        itemStyle: {
          normal:{
            show:false,
            color: 'rgba(0,159,154,1)'//边的颜色
          }

        },
        lineStyle: {
          // width:50,
          normal: {
            color: "rgba(0,159,154,1)"   // 线条颜色
          }
        },
        markPoint: {
          data: [
            {
              type: 'max',
              name: '最大值',
              symbol: 'circle',
              symbolSize: 20,
              itemStyle: {
                normal: {
                  color: '#28FCF0',
                  fontSize: 30,
}
              },
              label: {
                show: true,
                position: 'top', // 表现内容展示的位置
                formatter: '{a|发病率 : }{b|{c}}', // 标线展示的内容
                rich: {
                  a: {
                    fontSize: 26,
                    color:"#fff",
                  },
                  b: {
                    fontSize: 26,
                    color:"#fff",
                  }
                },
              },
            }


          ]
        },
        areaStyle: {
          normal:{
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 1,
              color: 'rgba(0,159,154,0)'
            }, {
              offset: 0.8,
              color: 'rgba(0,159,154,0.2)'
            },{
              offset: 0.6,
              color: 'rgba(0,159,154,0.6)'
            }, {
              offset: 0.4,
              color: 'rgba(0,159,154,0.6)'
            },{
              offset: 0,
              color: 'rgba(0,159,154,0.8)'
            }])
          }

        },
        data: data
      }
    ]
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});
function splitArray(array, size) {
  var result = Array.from({ length: Math.ceil(array.length / size) }, function(_, index) {
    return array.slice(index * size, index * size + size);
  });
  return result;
}
</script>
<style lang="less"></style>
